var timeleft = 120;
function countDown() {
  var downloadTimer = setInterval(function(){
    if(timeleft <= 20) {
      document.getElementById("timer-countdown").style.display = 'inline';
    } else {
      document.getElementById("timer-countdown").style.display = 'none';
    }
    if(timeleft <= 0){
      clearInterval(downloadTimer);
      document.location.href = wpData.siteUrl;
    } else {
      document.getElementById("countdown").innerHTML = timeleft;
    }
    timeleft -= 1;
  }, 1000);
}

function resetContDown() {
  timeleft = 120;
}

function onUserInteraction(callback) {
  const events = [
    'mousedown',    // click
    'mousemove',    // movimento mouse
    'keydown',      // tasto premuto
    'touchstart',   // tocco su mobile
    'scroll',       // scroll
    'wheel',        // rotellina mouse
    'pointerdown'   // eventi misti
  ];

  const handler = (e) => {
    callback(e);
  };

  events.forEach(event => {
    window.addEventListener(event, handler, { passive: true });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Verifica se NON sei nella homepage
  if (window.location.pathname !== '/' && window.location.pathname !== '/index.php') {
    onUserInteraction(() => {
      resetContDown();
    });

    countDown();
  }
});
